import { render } from "./dlg-corporation.vue?vue&type=template&id=b562ee34"
import script from "./dlg-corporation.vue?vue&type=script&lang=js"
export * from "./dlg-corporation.vue?vue&type=script&lang=js"

import "./dlg-corporation.vue?vue&type=style&index=0&id=b562ee34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__